import React from 'react';
import {Button,  ConfigProvider, Table} from "antd";
import {connect} from "react-redux";
import getLogs from '../../actions/getLogs';
import {formValueSelector} from "redux-form";
import modalShow from '../../actions/modalShow';
import LogsTableHeader from './LogsTableHeader';
import './report.css';
import PrivateRoute from "../Main/PrivateRoute";
import 'antd/lib/alert/style/css';
import 'antd/lib/button/style/css';
import 'antd/lib/card/style/css';
import 'antd/lib/pagination/style/css';
import 'antd/lib/row/style/css';
import 'antd/lib/select/style/css';
import getAllLogOperations from "../../actions/getAllLogOperations";
import getReports from "../../actions/getReports";
import modalDismiss from "../../actions/modalDismiss";
import 'antd/lib/table/style/css';
import languages from "../../language/languages";
import esCO from "antd/es/locale/es_ES";
import enUS from "antd/es/locale/en_US";
import {DATES_MODAL} from "../Modal/types";

class Report extends React.Component {

  state = {
    sidx: '',
    sord: '',
    filter: false,
    formValues : {},
    pagination: {size:'small',current:1,pageSize:10,defaultPageSize:10,defaultCurrent:1,showSizeChanger:true,pageSizeOptions:['10', '100', '1000']}
  };

  componentDidMount() {
    this.setInitialFilterValues(this.props.userReportList.kind);
    this.props.getAllLogOperations();
  }

  handleClean = () => {
    this.setInitialFilterValues(this.props.userReportList.kind);
  };

  handleFilter = (formValues) => {
    this.setState({page: 1, filter: true, formValues: formValues}, () =>  this.handleChange(this.props.userReportList.kind))
  };

  setInitialFilterValues = (value) => {
    if (value === 'logs') {
      this.setState({page: 1, sord: 'descend', sidx: 'date', filter: false, formValues: {whereColumn: 'userName', whereOp: '=', whereValue: ''}}, () =>  this.handleChange(value));
    } else {
      return null;
    }
  };

  handleExport = () =>
  {
    this.handleChange(this.props.userReportList.kind, true);
  };

  handleChange = (value, isExport = false) => {
    let filterValues={limit:this.state.pagination.pageSize,page:this.state.pagination.current, orderColumn:this.state.sidx, asc:  this.state.sord && (this.state.sord==='true' || this.state.sord ==='ascend'),export:isExport};
    Object.assign(filterValues,this.state.formValues);
    if (value === 'logs') {
      this.props.getLogs(filterValues,this.handleTotal);
    } else {
      return null;
    }
  };

  handleTotal=(data)=>
  {
    const pagination = { ...this.state.pagination };
    pagination.total = data.total;
    pagination.showTotal=(total) => 'Total: ' + total;
    this.setState({      pagination    });
  };

  handleSort = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    let pageSize=pagination.pageSize;
    if(!pageSize || pageSize<1)
      pageSize=this.state.pagination.defaultPageSize;
    pager.current = pagination.current;
    pager.pageSize=pageSize;
    if(sorter.field !== undefined) {
      this.setState({pagination: pager,sidx: sorter.field, sord: sorter.order}, () => this.handleChange(this.props.userReportList.kind));
    } else {
      this.setState({pagination: pager,sidx: '', sord: ''}, () => this.handleChange(this.props.userReportList.kind));
    }
  };

  columns = () => {
    if (this.props.userReportList.kind === 'logs') {
      return (
        [{
          title: languages[this.props.language].date_column,
          dataIndex: 'date',
          className: 'mobile-show',
          sortDirections: ['ascend', 'descend'],
          render :(text,record)=> <span>{record.dateString}</span> ,
          sorter: () => true,
          sortOrder: this.state.sidx === 'date' ? this.state.sord : false
        }, {
          title: languages[this.props.language].user_column,
          dataIndex: 'userName',
          className: 'mobile-show',
          sortDirections: ['ascend', 'descend'],
          sorter: () => true,
          sortOrder: this.state.sidx === 'userName' ? this.state.sord : false
        }, {
          title: languages[this.props.language].operation_column,
          dataIndex: 'operation',
          className: 'mobile-show',
          sortDirections: ['ascend', 'descend'],
          sorter: () => true,
          sortOrder: this.state.sidx === 'operation' ? this.state.sord : false
        }, {
          title: languages[this.props.language].detail_column,
          dataIndex: 'detail',
          className: 'mobile-hide'
        }, {
          title: languages[this.props.language].ip_column,
          dataIndex: 'ip',
          className: 'mobile-hide'
        }]
      );
    } else {
      return null;
    }
  };

  renderHeader = () => {
    if (this.props.userReportList.kind === 'logs') {
      return(
        <LogsTableHeader initValuesFunction={this.props.initialize} logOperations={this.props.logOperations} language={this.props.language} handleExport={this.handleExport} filter={this.state.filter} handleClean={this.handleClean} handleFilter={this.handleFilter} initialValues={this.state.formValues} getLogs={this.props.getLogs} whereColumn={this.props.whereColumn}/>
      );
    } else {
      return null;
    }

  };

  openDatesModal=()=>
  {
    let general=this;
    let message=languages[this.props.language].reportsONACLabel;
    this.props.modalShow({
      modalType: DATES_MODAL,
      modalProps: {footer: null, title: languages[this.props.language].confirmTitle},
      componentProps: {onOK:(form) =>{general.props.modalDismiss();general.props.getReports(form);},btnOK:languages[this.props.language].btnOK,btnCancel:languages[this.props.language].btnCancel,onCancel: () =>{general.props.modalDismiss()},message:message}
    });
  };

  render() {

    let dats=[];
	//Workaround to show data in it's correct order
    if(this.props.userReportList.entries)
    {
      dats = [...this.props.userReportList.entries];
      if (this.state.sord && this.state.sord === 'descend')
        dats.reverse();
      //End workaround
    }
	return (
        <div className="card-container h-100 p-20">

            <ConfigProvider locale={this.props.language==='es'?esCO:enUS}>
              <Button  htmlType={'button'} type={'primary'} onClick={this.openDatesModal}>{languages[this.props.language].reportsButton}</Button>
            <Table

              bordered
              pagination={this.state.pagination}
              columns={this.columns()}
              dataSource={dats}
              title={this.renderHeader}
              rowKey={(record) => this.props.userReportList.kind === 'logs' ? record.id : `${record.userName}-${record.fileName}-${record.documentType}`}
              onChange={this.handleSort}
            />
            </ConfigProvider>
        </div>
    );
  };

}

const logSelector = formValueSelector('logs_report_form');

const mapStateToProps = state => {
  return {
    language: state.auth.language,
    whereColumn: logSelector(state, 'whereColumn'),
    userReportList: state.users.reports,
    logOperations:state.system.logOperations
  };
};

export default PrivateRoute(connect(mapStateToProps, {getLogs, modalShow,getAllLogOperations,getReports,modalDismiss})(Report));
